import useWindowDimensions from "hooks/dimensions/useWindowDimensions";
import Breakpoint from "types/enums/Breakpoint";

export default function useIsBottomTabsWidth(): boolean {
  const { width } = useWindowDimensions();

  return width <= Breakpoint.Width768;
}
